function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "logo-bars",
  strokeWidth: 1.75
}, /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#db3b3e",
  d: "M0 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#953131",
  d: "M8.89 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#da6d41",
  d: "M17.78 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#c19d50",
  d: "M26.67 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#97a758",
  d: "M35.56 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#8ac554",
  d: "M44.45 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#3b733c",
  d: "M53.34 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#2b5e5b",
  d: "M62.24 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#7da298",
  d: "M71.12 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#59b4a3",
  d: "M80.02 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#46b4cd",
  d: "M88.91 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#507dba",
  d: "M97.8 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#475390",
  d: "M106.69 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#684b83",
  d: "M115.59 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#9a4b98",
  d: "M124.47 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#846ead",
  d: "M133.36 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#867078",
  d: "M142.25 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#71493d",
  d: "M151.15 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#b58374",
  d: "M160 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#c39a8e",
  d: "M168.93 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#d986b7",
  d: "M177.9 32.52h9",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}), /*#__PURE__*/React.createElement("path", {
  className: "logo-bar",
  stroke: "#d44a99",
  d: "M186.71 32.52h8.89",
  transform: "matrix(.92025 0 0 1 0 -.679)"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 195.6 50.22",
    enableBackground: "new 0 0 195.6 50.22",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    className: "logo-title",
    "aria-label": "Sprachen",
    style: {
      fontSize: "34.6667px",
      lineHeight: 1.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.793 7.447c-1.386-.971-3.536-1.56-5.581-1.56-5.165 0-8.91 3.154-8.91 7.557 0 2.184.971 4.09 2.635 5.165 1.214.763 1.907 1.006 5.998 2.01l3.432.868c2.6.658 3.328 1.178 3.328 2.46 0 1.804-1.803 3.086-4.368 3.086-2.427 0-4.854-1.074-6.587-2.877-.936-1.04-1.595-1.907-2.496-3.536l-2.6.867 2.877 8.84h2.046l.485-1.7c1.456 1.076 3.848 1.769 6.205 1.769 5.651 0 9.811-3.536 9.811-8.32 0-2.15-.936-4.056-2.53-5.096-1.04-.693-1.977-1.04-4.958-1.837l-3.155-.832c-.069-.035-.728-.174-1.698-.382a8.46 8.46 0 0 1-1.803-.59c-.832-.346-1.248-.935-1.248-1.663 0-1.421 1.595-2.427 3.813-2.427 1.976 0 4.126.936 5.443 2.358.59.624 1.04 1.178 2.15 2.704l2.495-.936-2.288-7.038h-2.08ZM37.116 12.543h-2.15l-5.407 1.005v2.808l.624.07c1.56.207 1.941.797 1.906 2.842v12.376c-.034 2.045-.138 2.288-1.525 2.635l-1.005.242v2.808h10.677v-2.808l-1.005-.242c-1.387-.347-1.491-.59-1.526-2.635v-2.357c2.288.866 2.774.97 4.16.97 4.68 0 8.112-3.917 8.112-9.29 0-4.923-3.57-8.736-8.216-8.736-1.525 0-2.426.277-4.645 1.317zm.59 4.472c.762-.867 1.94-1.422 3.015-1.422 2.08 0 3.363 2.01 3.363 5.27 0 3.709-1.352 5.858-3.71 5.858-.9 0-1.975-.416-2.669-1.074zM59.303 12.543h-2.15l-5.408 1.005v2.808l.624.07c1.56.207 1.942.797 1.907 2.842v4.992c-.035 2.045-.139 2.288-1.525 2.635l-1.006.242v2.808h10.678v-2.808l-1.006-.242c-1.386-.347-1.49-.59-1.525-2.635v-6.725c.485-.416.832-.555 1.387-.555.416 0 .416 0 1.213.52.659.416 1.075.555 1.768.555 1.595 0 2.739-1.11 2.739-2.635 0-1.837-1.352-3.19-3.12-3.19-1.456 0-2.288.382-4.576 2.011zM85.65 26.132c-.625.59-.625.59-.867.59-.243 0-.52-.174-.59-.382-.104-.243-.104-.243-.138-1.56v-6.83c0-1.837-.382-2.946-1.318-3.847-1.213-1.18-3.501-1.872-6.24-1.872-4.472 0-7.696 2.01-7.696 4.784 0 1.49 1.11 2.6 2.566 2.6 1.698 0 2.704-1.006 2.669-2.67 0-.485.07-.728.312-.901.416-.381 1.179-.624 1.907-.624 1.49 0 2.184.59 2.184 1.872v1.768c-1.907.173-3.571.485-5.062.936-3.466 1.04-5.2 2.877-5.2 5.512 0 2.843 2.219 4.75 5.512 4.75 1.976 0 3.744-.59 5.512-1.769.832 1.075 2.358 1.768 3.987 1.768 1.56 0 2.843-.52 4.403-1.768zm-7.211-.832c-.902.832-1.768 1.213-2.74 1.213-.97 0-1.628-.693-1.628-1.733 0-1.49 1.386-2.392 4.368-2.947zM103.572 23.497c-1.248 2.288-2.877 3.398-4.888 3.398-2.496 0-4.125-2.358-4.125-5.963 0-3.536 1.178-5.512 3.328-5.512 1.074 0 1.976.624 1.976 1.387l-.035 1.005c0 1.213 1.387 2.357 2.877 2.357 1.63 0 2.878-1.213 2.878-2.842 0-2.843-3.398-5.096-7.696-5.096-5.755 0-9.5 3.57-9.5 9.013 0 5.339 3.78 9.013 9.257 9.013 4.125 0 7.315-1.941 8.736-5.304zM116.19 17.327c.833-.728 2.566-1.352 3.71-1.352.97 0 1.456.693 1.456 2.149v6.136c-.035 2.045-.104 2.184-1.525 2.704l-.451.173v2.808h10.365v-2.808l-1.248-.242c-1.386-.382-1.49-.59-1.525-2.635v-6.587c0-1.941-.381-3.016-1.456-3.986-1.005-.936-2.392-1.456-3.917-1.456-1.907 0-3.363.416-5.408 1.56V4.847h-2.254c-2.184.936-4.541 1.525-6.101 1.49v2.808l.693.07c1.768.312 2.08.728 2.046 2.808V24.26c-.035 2.045-.139 2.253-1.526 2.635l-1.213.242v2.808h10.33v-2.808l-.45-.173c-1.421-.52-1.49-.659-1.525-2.704zM149.228 21.14c0-2.461-.277-3.917-.901-5.061-1.352-2.427-4.126-3.848-7.488-3.848-5.339 0-9.118 3.709-9.118 8.944 0 5.304 3.952 9.082 9.43 9.082 2.634 0 5.026-.936 6.552-2.6.658-.693 1.074-1.248 1.941-2.67l-2.912-1.42c-1.352 2.01-2.773 2.946-4.541 2.946-2.704 0-4.23-1.976-4.195-5.373zm-11.024-2.67c.104-1.906 1.04-3.05 2.6-3.05s2.219.867 2.288 3.05zM159.073 12.543h-2.149l-5.408 1.005v2.808l.624.07c1.56.207 1.941.797 1.907 2.842v4.992c-.035 2.045-.139 2.288-1.526 2.635l-1.005.242v2.808h10.296v-2.808l-.624-.173c-1.283-.312-1.525-.763-1.525-2.704V17.5c1.421-.97 2.912-1.525 3.952-1.525s1.56.762 1.56 2.218v6.067c0 1.941-.243 2.392-1.526 2.704l-.624.173v2.808h10.331v-2.808l-1.04-.242c-1.387-.382-1.49-.59-1.525-2.635v-6.517c0-1.872-.312-2.843-1.283-3.883-1.04-1.144-2.253-1.63-4.125-1.63-2.184 0-4.022.52-6.31 1.803z",
    style: {
      fontWeight: 600,
      fontFamily: "'URW Bookman'",
      InkscapeFontSpecification: "'URW Bookman, Semi-Bold'"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "logo-subtitle",
    "aria-label": "Berlins",
    style: {
      fontSize: "21.3333px",
      lineHeight: 1.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.67 34.649v1.75l.426.042c1.237.17 1.472.448 1.45 1.792v7.36c.022 1.344-.213 1.621-1.45 1.792l-.427.042v1.75h8.534c1.984 0 2.901-.17 3.84-.704 1.237-.726 1.984-2.048 1.984-3.563 0-1.728-.94-2.965-2.688-3.541 1.28-.64 2.048-1.77 2.048-3.072 0-.96-.427-1.899-1.174-2.56-.853-.768-2.176-1.088-4.437-1.088zm5.61 5.781v-2.645c0-.427.021-.619.107-.747.128-.235.746-.363 1.664-.363 1.706 0 2.709.726 2.709 1.942 0 1.152-1.024 1.813-2.773 1.813zm0 1.963h1.77c2.177 0 3.094.682 3.094 2.325 0 1.6-1.13 2.56-3.008 2.56-.832 0-1.472-.15-1.685-.384-.128-.15-.171-.32-.171-.704zM78.037 43.758c0-1.515-.17-2.41-.554-3.115-.832-1.493-2.54-2.368-4.608-2.368-3.286 0-5.611 2.283-5.611 5.504 0 3.264 2.432 5.59 5.803 5.59 1.62 0 3.093-.576 4.032-1.6.405-.427.66-.768 1.194-1.643l-1.792-.875c-.832 1.238-1.706 1.814-2.794 1.814-1.664 0-2.603-1.216-2.582-3.307zm-6.784-1.643c.064-1.173.64-1.877 1.6-1.877.96 0 1.366.533 1.408 1.877zM84.096 38.467h-1.323l-3.328.62v1.727l.384.043c.96.128 1.195.49 1.174 1.75v3.071c-.022 1.259-.086 1.408-.94 1.621l-.618.15v1.728h6.57v-1.728l-.618-.15c-.853-.213-.917-.362-.938-1.62v-4.14c.298-.256.512-.34.853-.34.256 0 .256 0 .747.32.405.255.66.34 1.088.34.98 0 1.685-.682 1.685-1.62 0-1.132-.832-1.964-1.92-1.964-.896 0-1.408.235-2.816 1.238z",
    style: {
      fontWeight: 600,
      fontFamily: "'URW Bookman'",
      InkscapeFontSpecification: "'URW Bookman, Semi-Bold'"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.867 33.731h-1.408c-1.323.576-2.24.79-3.67.918v1.728l.363.042c1.088.192 1.28.427 1.259 1.728v7.531c-.022 1.259-.086 1.387-.94 1.621l-.682.15v1.728h6.678v-1.728l-.662-.15c-.853-.234-.917-.362-.938-1.62zM101.397 38.467h-1.322l-3.755.62v1.727l.448.043c.96.128 1.195.49 1.173 1.75v3.071c-.021 1.259-.085 1.387-.938 1.621l-.683.15v1.728h6.677v-1.728l-.661-.15c-.853-.234-.917-.362-.939-1.62zm-1.856-4.864c-1.152 0-2.112.96-2.112 2.091a2.03 2.03 0 0 0 2.027 2.048 2.13 2.13 0 0 0 2.112-2.112c0-1.152-.875-2.027-2.027-2.027zM108.65 38.467h-1.322l-3.328.62v1.727l.384.043c.96.128 1.195.49 1.173 1.75v3.071c-.021 1.259-.085 1.408-.938 1.621l-.62.15v1.728h6.337v-1.728l-.384-.107c-.79-.192-.939-.47-.939-1.664v-4.16c.875-.597 1.792-.939 2.432-.939.64 0 .96.47.96 1.366v3.733c0 1.195-.15 1.472-.938 1.664l-.384.107v1.728h6.357v-1.728l-.64-.15c-.854-.234-.918-.362-.939-1.62v-4.012c0-1.152-.192-1.749-.79-2.389-.64-.704-1.386-1.003-2.538-1.003-1.344 0-2.474.32-3.882 1.11zM127.36 38.467h-1.344l-.256.512c-1.152-.554-1.75-.704-2.752-.704-2.517 0-4.33 1.558-4.33 3.734 0 1.728 1.194 2.837 3.413 3.136l1.365.17c1.322.192 1.877.47 1.877.982 0 .49-.81.896-1.856.896-.853 0-1.77-.32-2.368-.854-.256-.213-.448-.426-.96-1.024l-1.642.342.853 3.605h1.408l.256-.533c1.11.49 1.77.64 2.794.64 2.667 0 4.715-1.686 4.715-3.84 0-.832-.299-1.6-.875-2.134-.576-.576-1.024-.768-2.624-1.066l-1.6-.299c-1.194-.213-1.663-.49-1.663-.96s.618-.832 1.471-.832c1.088 0 1.963.512 2.774 1.643l1.75-.256z",
    style: {
      fontWeight: 600,
      fontFamily: "'URW Bookman'",
      InkscapeFontSpecification: "'URW Bookman, Semi-Bold'"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c103a59f.svg";
export { ForwardRef as ReactComponent };